import { useState, useContext } from 'react';

import Input from '../../../../../components/inputs/inputs-text';
import Checkbox from '../../../../../components/checkbox';

import Popup from '../../../../../components/popup';

import Row from '../../../../../utils/row';

import { DeleteButton, CancelButton } from '../../../../../components/buttons';

import ELearningApi from '../../../../../lib/e-learning/e-learning-api';
import LabelContainer from '../../../../../components/label-container';

import AlertManager from '../../../../../managers/alert/alert-manager';

import PopupContext from '../../../../../context/context-popup';

export default function CourseModuleDelete({ onSuccess }) {
    const { setPopup } = useContext(PopupContext);
    
    const clicked = () => onSuccess();

    return (
        <Popup onClose={setPopup}>
            <div class="popup__inner">
                <h1>Are you sure?</h1>
                <p>You are about to delete a module, this cannot be undone</p>

                <div class="popup__buttons">
                    <DeleteButton responsive={false} onClick={clicked}/>
                    <CancelButton responsive={false} onClick={() => setPopup(null)}/>
                </div>
            </div>
        </Popup>
    )
}
